













import { Component, Vue, Mixins } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'
import { ACCESS_KNOW_URL } from '@/apps/open/constants'
import { getDomainWhitelist, updateDomainWhitelist } from '@/apps/open/services/app'
import EditDomainWhitelistDialogBody from '@/apps/open/components/DialogBodys/app/EditDomainWhitelist.vue'
import { ErrorCode } from '@/apps/open/utils/axios'
import { onRequestError } from '@/apps/open/utils'

@Component({
  components: {
    Button
  },
  data: () => ({
    DOMAIN_URL: ACCESS_KNOW_URL
  })
})
export default class DomainWhitelistSetting extends Vue {
  title = '域名白名单'
  domainList: string[] = []
  submitCount = 0
  submitting = false

  get appId () {
    return this.$route.params.id
  }

  get viewable () {
    return this.domainList.length > 0
  }

  get editable () {
    return this.submitCount > 0
  }

  viewDomainWhitelist () {
    const dialogButtons = []
    const cancelBtn = { text: '取消' }
    const okBtn: any = {
      text: this.editable ? '修改' : '确定',
      type: 'primary',
      fn: this.editable ? this.setDomainWhitelist : this.$dialog.close
    }
    if (!this.editable) {
      dialogButtons.push(cancelBtn)
    }
    dialogButtons.push(okBtn)
    this.$dialog.show({
      title: this.title,
      body: this.domainList.join('<br>'),
      buttons: dialogButtons
    })
  }

  setDomainWhitelist () {
    this.$dialog.show({
      title: this.title,
      body: EditDomainWhitelistDialogBody,
      bodyProps: {
        appId: this.appId,
        domainList: this.domainList.length ? [...this.domainList] : [''],
        submitCount: this.submitCount,
        onCancel: this.$dialog.close,
        onOk: this.submitDomain
      }
    })
  }

  async load () {
    try {
      const data = await getDomainWhitelist(this.appId)
      this.setData(data.data)
    } catch (error) {
      onRequestError(error)
    }
  }

  setData (data: any) {
    this.submitCount = data.times
    this.domainList = []
    Object.keys(data).forEach(key => {
      if (/^domain/.test(key) && data[key]) {
        this.domainList.push(data[key])
      }
    })
  }

  async submitDomain (domainList: string[]) {
    if (domainList.join(',') === this.domainList.join(',')) {
      this.$message.warning('域名没有更新，无需重复配置')
    } else {
      try {
        this.submitting = true
        const res = await updateDomainWhitelist(this.appId, domainList)
        const data = res.data
        if (data.result !== ErrorCode.OK) {
          this.$message.error(data.msg)
          return
        }
        this.setData(data)
        this.$message.success('域名白名单保存成功')
      } catch (error) {
        onRequestError(error)
      }
    }
    this.$dialog.close()
    this.submitting = false
  }

  mounted () {
    this.load()
  }
}
